import { Box } from "@mui/material";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import caseTypes from "../../configs/caseTypeConfig";
import { getOptionalCasesDetails } from "../Cases/GeneralCases/CaseUtils";
import "./AuditAnalysis.scss";
import { PieChart } from 'react-minimal-pie-chart';


const AuditAnalysis = () => {
  const dispatch = useDispatch();
  const defaultAccount = useSelector(
    (state: any) => state.account.default_account
  );
  let optionalCasesDetails = useSelector(
    (state: any) => state.case.optional_cases_details
  );

  useEffect(() => {
    if (defaultAccount && defaultAccount.id) {
      getOptionalCasesDetails(dispatch, defaultAccount.id);
    }
  }, [defaultAccount]);

  const getTotalAmount = () => {
    return (optionalCasesDetails.reduce((total, currentItem) =>
      total = total + (caseTypes.hasOwnProperty(currentItem.type) ?
        currentItem.sum : 0), 0)).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
  };

  const getCasesChart = () => {
    let chartArray = [];
    optionalCasesDetails.forEach(element => {
      if (caseTypes.hasOwnProperty(element.type)) {
        chartArray.push({
          title: caseTypes[element.type].title,
          value: element.sum, color: caseTypes[element.type].color
        })
      }
    });
    return chartArray;
  }

  return (
    <Box sx={{ paddingTop: "15px" }}>
      <h2>Audit Analysis</h2>
      <Box sx={{ display: "flex", justifyContent: 'space-between', paddingTop: "15px" }}>
        <Box sx={{ width: "68%" }}>
          {optionalCasesDetails.map((item) =>
            caseTypes.hasOwnProperty(item.type) && <Box className="case-box" key={item.type}  >
              <Box sx={{
                borderRadius: "12px 0 0 12px",
                bgcolor: () => (caseTypes[item.type].color),
                height: "100%", width: "11px", float: "left"
              }}></Box>
              <Box sx={{ padding: "10px 6px 0 25px" }}>
                <p className="bold">
                  <span className="mr-10p">${item.sum.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}</span>
                  {caseTypes[item.type].title}</p>
                <p>{caseTypes[item.type].description}</p>
              </Box>
            </Box>

          )}
        </Box>
        <Box sx={{ width: "30%" }}>
          <Box className="summary-box">
            <Box>
              <span className="text-summary">Better Refunds will recover up to:</span>
              <span className="text-summary">${getTotalAmount()}</span>
              <hr className="summary-line"></hr>
              <span className="text-summary">2.1% of FBA Sales</span>
            </Box>
          </Box>
          <Box className="reimbursements-box">
            <Box className="internal-reimbursements-box">
              <span className="text-reimbursements">Reimbursements</span>
              <PieChart className="reimbursements-chart" lineWidth={28}
                data={getCasesChart()}
              />
              <span className="text-reimbursements center-chart">${getTotalAmount()}</span>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>


  );
};
export default AuditAnalysis;
